var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 8"}},[_c('path',{attrs:{"d":"M0 4.669h9.44L7.06 7.076l.94.937 4-4-4-4-.94.938 2.38 2.406H0v1.312z","fill":"#fff","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }